import { useEffect, useState } from "react";

const MONTH_LABEL = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-GB", { month: "short" });
};

export function Engagement({ chapterId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`/api/chapters/${chapterId}/engagement`, { credentials: "same-origin" })
      .then((res) => (res.ok ? res.json() : null))
      .then(setData);
  }, [chapterId]);

  if (data === null) return null;

  const maxAttend = Math.max(1, ...data.trend.map((t) => t.attendance));
  const maxScore = Math.max(1, ...data.top.map((t) => t.score));

  return (
    <div className="section">
      <div className="section-head">
        <h3>Growth & engagement (last 12 months)</h3>
      </div>

      <div className="stat-grid" style={{ marginBottom: 14 }}>
        <div className="stat">
          <div className="n" style={{ color: "var(--green)" }}>{data.buckets.engaged}</div>
          <div className="l">Engaged members (score ≥ 5)</div>
        </div>
        <div className="stat">
          <div className="n">{data.buckets.occasional}</div>
          <div className="l">Occasional (1–4)</div>
        </div>
        <div className="stat">
          <div className="n" style={{ color: "#b42318" }}>{data.buckets.inactive}</div>
          <div className="l">Not yet engaged</div>
        </div>
        <div className="stat">
          <div className="n">{data.member_count}</div>
          <div className="l">Roster total</div>
        </div>
      </div>

      <div className="form-card">
        <div className="l" style={{ color: "var(--muted)", fontSize: 13, marginBottom: 8 }}>
          Monthly attendance (bar), events held and new members
        </div>
        {data.trend.map((t) => (
          <div key={t.month} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 5 }}>
            <span className="muted" style={{ width: 34, fontSize: 12 }}>{MONTH_LABEL(t.month)}</span>
            <div className="bar" style={{ flex: 1 }}>
              <span style={{ width: `${(t.attendance / maxAttend) * 100}%` }} />
            </div>
            <span className="muted" style={{ width: 210, fontSize: 12 }}>
              {t.attendance} attended · {t.events} event{t.events === 1 ? "" : "s"}
              {t.new_members > 0 && (
                <span style={{ color: "var(--green)", fontWeight: 600 }}> · +{t.new_members} member{t.new_members === 1 ? "" : "s"}</span>
              )}
            </span>
          </div>
        ))}
      </div>

      {data.top.length > 0 && data.top[0].score > 0 && (
        <div className="form-card" style={{ marginTop: 12 }}>
          <div className="l" style={{ color: "var(--muted)", fontSize: 13, marginBottom: 8 }}>
            Most engaged members — event attendance, groups, volunteering, mentoring, voting
          </div>
          <table className="tbl">
            <tbody>
              {data.top.filter((t) => t.score > 0).map((t) => (
                <tr key={t.name}>
                  <td style={{ width: 180 }}>
                    {t.name}
                    {t.stage && <span className="muted" style={{ fontSize: 12 }}> · {t.stage}</span>}
                  </td>
                  <td>
                    <div className="bar">
                      <span style={{ width: `${(t.score / maxScore) * 100}%` }} />
                    </div>
                  </td>
                  <td style={{ width: 110, textAlign: "right", fontSize: 13 }}>
                    <strong>{t.score}</strong>
                    <span className="muted"> ({t.from_events} from events)</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
